import { object, string } from 'yup';
import { EuroValue } from '../../../common';
import {
  IAddressNullable,
  IAddressNullableInput,
  IAddressNullableSchema,
} from '../address/IAddressNullable';

export type IWelfareOffice = {
  id: string;
  name: string;
  address: IAddressNullable;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  email?: string | null;
  maxInvestmentCost: number | null;
  costObjectNumber: string;
  customCostObjectNumber?: string;
  dispatchEmail?: string | null;
};

export type IWelfareOfficeCreate = {
  name: string;
  address?: IAddressNullableInput;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  email?: string | null;
  maxInvestmentCost?: number | null;
  dispatchEmail?: string | null;
};

export const IWelfareOfficeCreateSchema = object({
  name: string().trim().required(),
  address: IAddressNullableSchema.optional().default(undefined),
  phoneNumber: string().trim().optional().nullable(),
  faxNumber: string().trim().optional().nullable(),
  email: string().trim().optional().nullable(),
  maxInvestmentCost: EuroValue.optional().nullable().default(null),
  customCostObjectNumber: string().trim().optional().nullable().default(undefined),
  dispatchEmail: string().trim().optional().nullable(),
});

export type IWelfareOfficeUpdate = {
  name?: string;
  address?: IAddressNullableInput;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  email?: string | null;
  maxInvestmentCost?: number | null;
  customCostObjectNumber?: string | null;
  dispatchEmail?: string | null;
};

export const IWelfareOfficeUpdateSchema = object({
  name: string().trim().optional(),
  address: IAddressNullableSchema.optional().default(undefined),
  phoneNumber: string().trim().optional().nullable(),
  faxNumber: string().trim().optional().nullable(),
  email: string().trim().optional().nullable(),
  maxInvestmentCost: EuroValue.optional().nullable().default(undefined),
  customCostObjectNumber: string().trim().optional().nullable().default(undefined),
  dispatchEmail: string().trim().optional().nullable(),
});
